import './toast.css'

export default function(text, t) {
	console.log("dfjdlskj")
	let time = (time) ? t : 3000

    let x = document.createElement("div")
    x.id = "toast"
    x.innerHTML = text
    x.className = "show";
    document.body.appendChild(x)
    setTimeout(function(){ x.className = x.className.replace("show", ""); }, time);
}